"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSlotDto = exports.ProblematicSlotDto = exports.DraftTimeSlotDto = exports.TimeSlotConflictsDto = exports.UpdateSlotsColorsDto = exports.SlotsIdsDto = exports.TimeSlotsDto = exports.TimeSlotDto = exports.DraftSlotDto = exports.DraftSlotsDto = exports.UpdateDraftSlotDto = exports.BaseDraftSlotDto = exports.SlotDto = exports.BaseSlotDto = exports.BaseSlotFieldsDto = exports.SlotProductPricesMetadataDto = exports.SlotProductMetadataDto = void 0;
class SlotProductMetadataDto {
}
exports.SlotProductMetadataDto = SlotProductMetadataDto;
class SlotProductPricesMetadataDto {
}
exports.SlotProductPricesMetadataDto = SlotProductPricesMetadataDto;
class BaseSlotFieldsDto {
}
exports.BaseSlotFieldsDto = BaseSlotFieldsDto;
class BaseSlotDto extends BaseSlotFieldsDto {
}
exports.BaseSlotDto = BaseSlotDto;
class SlotDto extends BaseSlotDto {
}
exports.SlotDto = SlotDto;
class BaseDraftSlotDto extends BaseSlotDto {
}
exports.BaseDraftSlotDto = BaseDraftSlotDto;
class UpdateDraftSlotDto {
}
exports.UpdateDraftSlotDto = UpdateDraftSlotDto;
class DraftSlotsDto extends BaseSlotFieldsDto {
}
exports.DraftSlotsDto = DraftSlotsDto;
class DraftSlotDto extends BaseDraftSlotDto {
}
exports.DraftSlotDto = DraftSlotDto;
class TimeSlotDto {
}
exports.TimeSlotDto = TimeSlotDto;
class TimeSlotsDto {
}
exports.TimeSlotsDto = TimeSlotsDto;
class SlotsIdsDto {
}
exports.SlotsIdsDto = SlotsIdsDto;
class UpdateSlotsColorsDto {
}
exports.UpdateSlotsColorsDto = UpdateSlotsColorsDto;
class TimeSlotConflictsDto {
}
exports.TimeSlotConflictsDto = TimeSlotConflictsDto;
class DraftTimeSlotDto {
}
exports.DraftTimeSlotDto = DraftTimeSlotDto;
class ProblematicSlotDto {
}
exports.ProblematicSlotDto = ProblematicSlotDto;
class CardSlotDto extends SlotDto {
}
exports.CardSlotDto = CardSlotDto;
//# sourceMappingURL=slot.dto.js.map